import { CheckmarkSmall as IconComponent } from '@adobe/react-spectrum-ui/dist/CheckmarkSmall.js';
import { UIIcon } from '@react-spectrum/icon';
import React from 'react';
export default function CheckmarkSmall(props) {
  return /*#__PURE__*/React.createElement(UIIcon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}